<script lang="ts">
  export let name: string
  export let required = true
</script>

<div class="label-component">
  <div class="label-styled">
    <label for={name}><slot /></label>

    {#if required}
      <span class="text-xl leading-none pb-1 ml-1px" aria-label="Required">*</span>
    {/if}
  </div>
</div>
